import { render, staticRenderFns } from "./Panico.vue?vue&type=template&id=5bcb2a68"
import script from "./Panico.vue?vue&type=script&lang=js"
export * from "./Panico.vue?vue&type=script&lang=js"
import style0 from "./Panico.vue?vue&type=style&index=0&id=5bcb2a68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports